import React from "react";
import { ProductAttributesModel } from "@admin/domain/products/models/edit/ProductAttributesModel";
import Texts from "./Texts";
import LabelTypes from "./LabelTypes";
import Input from "@admin/components/Input";
import CheckBox from "@admin/components/CheckBox";
import ProductMediaFiles from "./ProductMediaFiles/index";
import MultiLanguages from "@admin/components/MultiLanguage";
import PublicUrlInput from "@admin/components/PublicUrlInput";

type ProductAttributesProps = {
    productAttributes: ProductAttributesModel;
};

export default function ProductAttributes({
    productAttributes,
}: ProductAttributesProps) {
    return (
        <div className="rounded border p-10 mb-5">
            <h2 className="mb-5">Атрибуты товара</h2>

            <PublicUrlInput
                label="URL товара"
                defaultValue={productAttributes.url}
                publicUrl={productAttributes.url}
                readOnly
            />
            <p className="form-text mb-5">URL товара обновляется из 1С.</p>

            <MultiLanguages
                languageElement={(language) => (
                    <Texts language={language} texts={productAttributes.text} />
                )}
            />

            <ProductMediaFiles files={productAttributes.files} />

            <LabelTypes labelTypes={productAttributes.label_types} />

            <Input
                label="Приоритет товара в категории (из 1С)"
                name="product_attributes[priority]"
                type="number"
                min="0"
                defaultValue={productAttributes.priority ?? ``}
            />

            <Input
                label="Срок приёма одной упаковки, дней"
                aria-label="Срок приёма одной упаковки, дней"
                aria-describedby="product-course-days-hint"
                name="product_attributes[course_days]"
                type="number"
                min="1"
                max="36500"
                step="1"
                defaultValue={productAttributes.course_days ?? ``}
            />
            <p id="product-course-days-hint" className="form-text mb-5">
                Срок для этой фасовки. Оставьте поле пустым, если срок не задан.
                Изменение применяется к новым курсам.
            </p>

            <CheckBox
                name="product_attributes[is_public]"
                label="Опубликован"
                defaultChecked={productAttributes.is_public}
            />

            <CheckBox
                name="product_attributes[is_visiable]"
                label="Показывать в каталоге"
                defaultChecked={productAttributes.is_visiable}
            />

            <CheckBox
                name="product_attributes[is_unavailable_by_link]"
                label="Недоступен по ссылке"
                defaultChecked={productAttributes.is_unavailable_by_link}
            />

            <CheckBox
                name="product_attributes[is_discontinued]"
                label="Выведен из ассортимента"
                defaultChecked={productAttributes.is_discontinued}
            />

            <CheckBox
                name="product_attributes[honest_sign]"
                label="(Честный знак) Признак маркировки товара"
                defaultChecked={productAttributes.honest_sign}
            />

            <CheckBox
                name="product_attributes[not_medicinal_product]"
                label="Не является лекарственным средством"
                defaultChecked={productAttributes.not_medicinal_product}
            />

            <CheckBox
                name="product_attributes[is_not_discountable]"
                label="Не применять скидку"
                defaultChecked={productAttributes.is_not_discountable}
            />

            <CheckBox
                name="product_attributes[can_be_ordered]"
                label="Может быть добавлен в корзину покупателем"
                defaultChecked={productAttributes.can_be_ordered}
            />

            <CheckBox
                name="product_attributes[show_icon_in_my_org]"
                label="Показывать значок в МОЯ ОРГАНИЗАЦИЯ при покупке"
                defaultChecked={productAttributes.show_icon_in_my_org}
            />
        </div>
    );
}
